import { createContext } from "react";
import type { Store } from "../state/store";
import type { EditorActions, QueryMethods } from "../state/types";
import type { Resolver } from "../resolver/resolver";
import type { HistoryManager } from "../state/history";

export interface EditorContextValue {
  store: Store;
  actions: EditorActions;
  query: QueryMethods;
  resolver: Resolver;
  history: HistoryManager;
  connectorRegistry: Map<string, HTMLElement>;
}

export const EditorContext = createContext<EditorContextValue | null>(null);

// Node-level context for tracking which node a component belongs to
export const NodeContext = createContext<string | null>(null);

// Optional callback to decide if a node should render based on its props.
// Return false to hide the node. When no provider is set, all nodes render.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type NodeVisibilityFn = (props: Record<string, any>) => boolean;
export const NodeVisibilityContext = createContext<NodeVisibilityFn | null>(null);
